import type { BoxProps } from '@chakra-ui/react';
import { Box, HStack, Link } from '@chakra-ui/react';

import { i18n } from '@/__generated__/i18n';
import { NextLinkWithoutPrefetch } from '@/components/atoms/NextLinkWithoutPrefetch';

import { APP_AUTHOR } from '../../constants';

type FooterContentProps = BoxProps & {
  locale: string;
};

export const FooterContent: React.FC<FooterContentProps> = ({ locale, ...props }) => {
  const t = i18n(locale);
  return (
    <Box as="footer" px={4} {...props}>
      <HStack
        borderTopWidth={1}
        color="fg.muted"
        columnGap={8}
        fontSize="sm"
        py={4}
        rowGap={2}
        whiteSpace="nowrap"
        wrap="wrap"
      >
        <div>&copy; {APP_AUTHOR}</div>

        <HStack columnGap={4} rowGap={2} wrap="wrap">
          <Link href="https://www.willbooster.com/tos/" rel="noopener noreferrer" target="_blank">
            {t.components.footer.termsOfService()}
          </Link>
          <Link href="https://www.willbooster.com/privacy/" rel="noopener noreferrer" target="_blank">
            {t.components.footer.privacyPolicy()}
          </Link>
          <Link asChild>
            <NextLinkWithoutPrefetch href={`/${locale}/help/contact`}>
              {t.components.footer.contact()}
            </NextLinkWithoutPrefetch>
          </Link>
        </HStack>
      </HStack>
    </Box>
  );
};
